<div class="container g-0 m-0">
    <div class="row g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-9 ps-5">
                <h2 class="col title">
                    @if (isActive('token-load/token-load')) { {{ "REMOTECOMMAND_CREDITTOKEN" | translate }} }
                    @if (isActive('token-load/clear-credit')) { {{ "REMOTECOMMAND_CLEARCREDIT" | translate }} }
                    @if (isActive('token-load/clear-tamper')) { {{ "REMOTECOMMAND_CLEARTAMPER" | translate }} }
                </h2>
                <h6 class="col subtitle">
                    @if (isActive('token-load/token-load')) { {{ "TOKENLOAD_SUBTITLE" | translate }} }
                    @if (isActive('token-load/clear-credit')) { {{ "CLEARCREDIT_SUBTITLE" | translate }} }
                    @if (isActive('token-load/clear-tamper')) { {{ "CLEARTAMPER_SUBTITLE" | translate }} }
                </h6>
            </div>
            <div class="col-md-3 d-flex justify-content-end align-items-center gap-3 pe-5">
                <button class="col-auto add justify-content-center" (click)="navigate('upload/token')">
                    {{ "BULK_IMPORT" | translate }}
                </button>
                @if (isActive('token-load/token-load') && authService.isAuthorized([PermissionsEnum.Remotecommands_tokenload_execute])) {
                <button class="col-auto add justify-content-center" (click)="navigate('remote-command/token-load-setup')">
                    {{ "REMOTECOMMAND_TOKENLOAD" | translate }}
                </button>
                }
                @if (isActive('token-load/clear-credit') && authService.isAuthorized([PermissionsEnum.Remotecommands_clearcredit_execute])) {
                <button class="col-auto add justify-content-center" (click)="navigate('remote-command/clear-credit-setup')">
                    {{ "REMOTECOMMAND_CLEARCREDIT" | translate }}
                </button>
                }
                @if (isActive('token-load/clear-tamper') && authService.isAuthorized([PermissionsEnum.Remotecommands_cleartamper_execute])) {
                <button class="col-auto add justify-content-center" (click)="navigate('remote-command/clear-tamper-setup')">
                    {{ "REMOTECOMMAND_CLEARTAMPER" | translate }}
                </button>
                }
            </div>
        </div>
    </div>
    <div class="row g-0 m-0 mb-3 ps-3">
        <ul>
            @if(authService.isAuthorized([PermissionsEnum.Remotecommands_tokenload_view])){
            <li (click)="navigate('remote-command/token-load/token-load')"
                [class.active]="isActive('token-load/token-load')">
                {{ "REMOTECOMMAND_CREDITTOKEN" | translate }}
            </li>
            }
            @if(authService.isAuthorized([PermissionsEnum.Remotecommands_clearcredit_view])){
            <li (click)="navigate('remote-command/token-load/clear-credit')"
                [class.active]="isActive('token-load/clear-credit')">
                {{ "REMOTECOMMAND_CLEARCREDIT" | translate }}
            </li>
            }
            @if(authService.isAuthorized([PermissionsEnum.Remotecommands_cleartamper_view])){
            <li (click)="navigate('remote-command/token-load/clear-tamper')"
                [class.active]="isActive('token-load/clear-tamper')">
                {{ "REMOTECOMMAND_CLEARTAMPER" | translate }}
            </li>
            }
        </ul>
    </div>
    <div class="row g-0 m-0">
        <router-outlet></router-outlet>
    </div>
</div>
